import React, { useContext, useEffect, useState } from "react";

import PsContext from "../../context";

import { ActionSheet, Form, Toast } from "antd-mobile";
import { Button } from "react-bootstrap";
import {
  COURSE_TYPE_SORT_ORDER,
  courseName,
  customSorting,
  getDescSortOrder,
  groupByMultiple,
  upperCase,
  yearBySem,
} from "../../utils";

import { _listCurrentBatches } from "../../models/academicYears";
import { _ListHourPerDay } from "../../models/utilities";

const SelectRecords = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);
  const [batches, setBatches] = useState([]);
  const [courses, setCourses] = useState([]);
  const [coursesList, setCoursesList] = useState([]);
  const [showAllSem, setShowAllSem] = useState(false);

  const [showCourseType, setShowCourseType] = useState(false);
  const [showBatch, setShowBatch] = useState(false);
  const [showSemester, setShowSemester] = useState(false);
  const [showCourse, setShowCourse] = useState(false);
  const [showSection, setShowSection] = useState(false);

  const [selectedCourseType, setSelectedCourseType] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [selectedSemester, setSelectedSemester] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedSection, setSelectedSection] = useState("a");

  const [currentSem, setCurrentSem] = useState(null);
  const [courseDetails, setCourseDetails] = useState([]);
  const [attHourPerDay, setAttHourPerDay] = useState(null);

  useEffect(() => {
    listBathces();
  }, []);

  const listBathces = () => {
    context.setLoader(true);

    // Create the initial condition object
    let s = {
      status: 1,
      college_uuid: context.user.college_uuid,
    };

    // Add the allowed_courses condition if necessary
    if (props.allowdCoursesOnly) s.allowed_courses = 1;

    // Call the API with the condition object
    _listCurrentBatches(s).then((res) => {
      if (res) {
        let groupedCourses = groupByMultiple(res.courses, function (obj) {
          return [obj.coursetype];
        });
        setBatches(res.data);
        setCoursesList(res.courses);
        setCourses(groupedCourses);
        setCurrentSem(res.sem);
      }
      context.setLoader(false);
    });
  };

  const handleBatchClick = (v) => {
    let b = batches.find((item) => item.batch == v);
    if (b && b.current_semester) setSelectedSemester(b.current_semester);
    setSelectedBatch(v);
  };

  const courseTypeActions = () => {
    let res = customSorting(
      coursesList,
      COURSE_TYPE_SORT_ORDER,
      "academic_dept_type"
    );
    let m = groupByMultiple(res, function (obj) {
      return [obj.academic_dept_type];
    });
    let rv = [];
    m.map((item, i) => {
      let v = item[0].academic_dept_type;

      rv.push(<option value={v}>{upperCase(v)}</option>);
    });

    return rv;
  };

  const batchList = () => {
    let rv = [];
    let m = batches.sort(getDescSortOrder("batch"));
    m = m.filter(
      (item) => upperCase(item.type) == upperCase(selectedCourseType)
    );
    m.map((item, i) => {
      let batch = item.batch;
      /*rv.push({
        text: `${batch} - ${yearByBatch(batch, item.no_of_semesters)}`,
        key: batch,
        onClick: () => handleBatchClick(batch),
      });*/
      /* rv.push(
        <option value={batch}>
          {batch} - {yearByBatch(batch, item.no_of_semesters)}
        </option>
      );*/

      rv.push(
        <option value={batch}>
          {batch} - {yearBySem(item.semester)}
        </option>
      );
    });
    return rv;
  };

  const semesterOptions = (sem, csem = false) => {
    if (sem == csem) {
    }
    return (
      <option value={sem} selected={sem == csem ? "selected" : ""}>
        {upperCase(sem)}
      </option>
    );
  };

  /*  const loadSemester = () => {
    let rv = [];
    let m = batches.find((item) => item.batch == selectedBatch);
    if (!m) return;
    let no_of_semesters = m.no_of_semesters;
    let current_semester = m?.current_semester || null;
    //let yearValue = yearByBatch(m.batch);
    let yearValue = yearBySem(m.semester);

    if (upperCase(yearValue) == "I-YEAR") {
      Array.from({ length: 2 }, (v, i) => {
        rv.push(semesterOptions(i + 1, current_semester));
      });
    } else if (upperCase(yearValue) == "II-YEAR") {
      if (showAllSem) {
        rv.push(semesterOptions(1, current_semester));
        rv.push(semesterOptions(2, current_semester));
      }

      rv.push(semesterOptions(3, current_semester));
      rv.push(semesterOptions(4, current_semester));
    } else if (upperCase(yearValue) == "III-YEAR") {
      if (showAllSem) {
        rv.push(semesterOptions(1, current_semester));
        rv.push(semesterOptions(2, current_semester));
        rv.push(semesterOptions(3, current_semester));
        rv.push(semesterOptions(4, current_semester));
      }
      rv.push(semesterOptions(5, current_semester));
      rv.push(semesterOptions(6, current_semester));
    } else {
      Array.from({ length: m.no_of_semesters }, (v, i) => {
        rv.push(semesterOptions(i + 1, current_semester));
      });
    }

    return rv;
  }; */

  const loadSemester = () => {
    let rv = [];
    let batchData = batches.find((item) => item.batch == selectedBatch);
    if (!batchData) return;

    let current_semester = batchData?.current_semester || null;

    // Only display the current semester
    if (current_semester) {
      rv.push(semesterOptions(current_semester, current_semester));
    }

    return rv;
  };

  const loadPrograms = (rawData = false) => {
    let rv = [];

    let m = coursesList.filter(
      (item) =>
        upperCase(item.academic_dept_type) == upperCase(selectedCourseType)
    );

    if (m.length < 1) return rv;

    m = customSorting(m, ["regular", "self"], "coursetype");
    let ms = groupByMultiple(m, function (obj) {
      return [obj.coursetype];
    });
    ms.map((items, is) => {
      let __rv = [];
      items.map((item) => {
        __rv.push(
          <option value={item.course_uuid}>{courseName(item, true)}</option>
        );
      });
      rv.push(
        <optgroup label={upperCase(items[0].coursetype)}>{__rv}</optgroup>
      );
    });

    return rv;
  };

  const getCourseName = () => {
    if (!selectedCourse) return "";
    let m = courses.find((item) => item.id == selectedCourse);
    if (!m) return "";
    return `${m.degreename} - ${m.name} (${
      upperCase(m.dept_type) == "UNAIDED" ? "SF" : "R"
    })`;
  };

  const getSections = () => {
    let rv = [];
    rv.push(semesterOptions("a"));
    rv.push(semesterOptions("b"));
    rv.push(semesterOptions("c"));
    rv.push(semesterOptions("d"));
    return rv;
  };

  const onfinish = (values) => {
    let error = false;
    if (!selectedCourse && !props.withOutCourse) error = true;
    else if (!selectedSection && !props.withOutSection) error = true;
    else if (!selectedBatch) error = true;
    else if (!selectedCourseType) error = true;
    else if (!selectedSemester) error = true;
    if (error) {
      Toast.show({
        content: "Please Select all the fields",
      });
      return;
    }

    let rv = {
      course_uuid: selectedCourse,
      batch: selectedBatch,
      course_type: selectedCourseType,
      section: selectedSection,
      semester: selectedSemester,
      course_name: getCourseName(),
      course_details: courseDetails,
    };
    if (props.withAttHour) {
      rv.att_hour_per_day = attHourPerDay;
    }

    if (props.onSuccess) props.onSuccess(rv);
  };

  const handleCourseChange = (e) => {
    let v = e.target.value;
    let c = coursesList.find((item) => item.course_uuid == v);
    setSelectedCourse(v);
    if (c) setCourseDetails(c);
  };

  useEffect(() => {
    if (props.withAttHour && selectedCourse && selectedBatch) {
      loadAttHour(selectedCourse, selectedBatch);
    }
  }, [selectedCourse, selectedBatch]);
  const loadAttHour = (courseUuid, selBatch) => {
    setLoader(true);
    let s = {
      course_uuid: courseUuid,
      batch: selBatch,
      college_uuid: context.user.college_uuid,
    };
    _ListHourPerDay(s).then((res) => {
      if (res.status == "1") {
        setAttHourPerDay(res.data[0].att_hour_per_day);
      } else {
        Toast.show({
          content:
            "Hours per day not assigned for this course and batch, using master settings instead.",
        });
      }
      setLoader(false);
    });
  };

  return (
    <>
      <Form
        name="from"
        onFinish={onfinish}
        layout="horizontal"
        footer={
          <Button
            type="submit"
            variant="danger"
            size="lg"
            className="w-100 bg-theme"
          >
            Search
          </Button>
        }
      >
        <input
          type="hidden"
          name="course_details"
          value={JSON.stringify(courseDetails)}
        />
        {props.withAttHour && (
          <input type="hidden" name="att_hour_per_day" value={attHourPerDay} />
        )}

        <Form.Item name="course_type" label="Course Type">
          <select
            className="form-select form-select-sm fw-bold"
            onChange={(e) => setSelectedCourseType(e.target.value)}
          >
            <option value="">-</option>
            {courseTypeActions()}
          </select>
        </Form.Item>

        <Form.Item name="batch" label="Batch">
          <select
            className="form-select form-select-sm fw-bold"
            onChange={(e) => handleBatchClick(e.target.value)}
          >
            <option value="">-</option>
            {batchList()}
          </select>
        </Form.Item>

        <Form.Item name="semester" label="Semester">
          <select
            className="form-select form-select-sm fw-bold"
            onChange={(e) => setSelectedSemester(e.target.value)}
          >
            <option value="">-</option>
            {loadSemester()}
          </select>
        </Form.Item>

        {!props.withOutCourse && (
          <Form.Item name="course" label="Course">
            <select
              className="form-select form-select-sm fw-bold"
              onChange={(e) => handleCourseChange(e)}
            >
              <option value="">-</option>
              {loadPrograms()}
            </select>
          </Form.Item>
        )}

        {!props.withOutSection && (
          <Form.Item name="section" label="Section">
            <select
              className="form-select form-select-sm fw-bold"
              onChange={(e) => setSelectedSection(e.target.value)}
            >
              {getSections()}
            </select>
          </Form.Item>
        )}

        {/* <Form.Item
          name="course_type"
          label="Course Type"
          onClick={(e) => setShowCourseType(true)}
        >
          <label className="fw-bold">{upperCase(selectedCourseType)}</label>
        </Form.Item>

        <Form.Item
          name="batch"
          label="Batch"
          onClick={(e) => setShowBatch(true)}
        >
          <label className="fw-bold">
            {upperCase(selectedBatch)} - {yearByBatch(selectedBatch)}
          </label>
        </Form.Item>

        <Form.Item
          name="semester"
          label="Semester"
          onClick={(e) => setShowSemester(true)}
        >
          <label className="fw-bold">{selectedSemester}</label>
        </Form.Item>

        <Form.Item
          name="course"
          label="Course"
          onClick={(e) => setShowCourse(true)}
        >
          <label className="fw-bold">{getCourseName()}</label>
        </Form.Item>

        <Form.Item
          name="section"
          label="Section"
          onClick={(e) => setShowSection(true)}
        >
          <label className="fw-bold">{upperCase(selectedSection)}</label>
      </Form.Item>*/}
      </Form>

      <ActionSheet
        visible={showCourseType}
        actions={courseTypeActions()}
        onClose={() => setShowCourseType(false)}
      />

      <ActionSheet
        visible={showBatch}
        actions={batchList()}
        onClose={() => setShowBatch(false)}
      />

      <ActionSheet
        visible={showSemester}
        actions={loadSemester()}
        onClose={() => setShowSemester(false)}
        safeArea={true}
      />

      <ActionSheet
        visible={showCourse}
        actions={loadPrograms()}
        onClose={() => setShowCourse(false)}
        safeArea={true}
      />

      <ActionSheet
        visible={showSection}
        actions={getSections()}
        onClose={() => setShowSection(false)}
      />
    </>
  );
};
export default SelectRecords;
